import React, { useContext, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import DataLoading from "../components/DataLoading";
import DateInput from "../components/DateInput";
import DropDownList from "../components/DropDownList";
import MaskedInput2 from "../components/MaskedInput2";
import TextInput from "../components/TextInput";
import { UserContext } from "../components/UserContext";
import axiosInstance from "../helper/axios";
import Trans from "../helper/Trans";
import { notify } from "../helper/Helper";
import CountriesList from "../helper/CountriesList";
import Select2 from "../components/Select2";
import Modal from "react-modal";
const attApi = axiosInstance;

function Profile(props) {
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [formData, setFormData] = useState({});
  const [formMeta, setFormMeta] = useState({});
  const [reqCols, setReqCols] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [dp, setDp] = useState("/imgs/face.png");
  const [disImg, setDisImg] = useState("");
  const [hqImg, setHqImg] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [allowSave, setAllowSave] = useState(false);
  const [allowImgChange, setAllowImgChange] = useState(true);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  const bloodGroups = {
    "A+": "A+",
    "B+": "B+",
    "O+": "O+",
    "AB+": "AB+",
    "A-": "A-",
    "B-": "B-",
    "O-": "O-",
    "AB-": "AB-",
  };
  const {
    setTitle,
    setOperation,
    setPLink,
    siteInfo,

    applicantStatus,
    getFillStatus,
  } = useContext(UserContext);
  useEffect(() => {
    setTitle("Personal Information");
    setOperation("Add Personal Information");
    setPLink("");
  }, [setTitle, setOperation, setPLink]);

  useEffect(() => {
    if (applicantStatus) {
      if (applicantStatus.personalInfo) {
        setOperation("Update Personal Information");
      }
    }
  }, [applicantStatus, setOperation]);
  useEffect(() => {
    setLoading(true);
    if (siteInfo !== null) {
      attApi.get("get-personal-info").then((response) => {
        if (response.data.success === false) {
          navigate("/");
          notify(response.data.msg, "error");
          setLoading(false);
          return;
        }
        setFormData(response.data.data);
        setFormMeta(response.data.meta);
        setReqCols(response.data.required);
        setAllowSave(response.data.allowSave);
        setAllowImgChange(response.data.allowImgChange);
        setDp(
          response.data.data.img === ""
            ? "/imgs/face.png"
            : process.env.REACT_APP_BACKEND_URL2 + response.data.data.img
        );
        setDisImg(
          response.data.data.disability_img === ""
            ? ""
            : process.env.REACT_APP_BACKEND_URL2 +
                response.data.data.disability_img
        );
        setHqImg(
          response.data.data.hq_image === ""
            ? ""
            : process.env.REACT_APP_BACKEND_URL2 + response.data.data.hq_image
        );

        setLoading(false);
      });
    }
  }, [siteInfo, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const onImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      const { name } = e.target;
      if (name === "img") {
        setDp((window.URL || window.webkitURL).createObjectURL(img));
      } else if (name === "disability_img") {
        setDisImg((window.URL || window.webkitURL).createObjectURL(img));
      } else if (name === "hq_image") {
        setHqImg((window.URL || window.webkitURL).createObjectURL(img));
      }

      setFormData({
        ...formData,
        [name]: img,
      });
    }
  };

  /*
  function validateDateofBirth(dateOfBirth) {
    const dobParts = dateOfBirth.split("-");
    const yearOfBirth = parseInt(dobParts[2], 10);
    const currentYear = new Date().getFullYear();

    if (currentYear - yearOfBirth < 10) {
      return false;
    }
    return true;
  }
*/
  function saveData(e) {
    let btnName = e.target.name;
    e.preventDefault();
    const newErrors = {};

    reqCols.forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = `${formMeta[key]} cannot be blank.`;
        // console.log(formMeta[key]);
      }
    });

    if (formData.disability === "1" && formData.disability_nature === "") {
      newErrors[
        "disability_nature"
      ] = `${formMeta["disability_nature"]} cannot be blank.`;
      // console.log( "disability_nature");
    }
    if (formData.hafizquran === "1" && formData.hq_image === "") {
      newErrors["hq_image"] = `${formMeta["hq_image"]} cannot be blank.`;
      // console.log( "disability_nature");
    }
    /*
    if (!/^[A-Za-z ]{3,100}$/.test(formData["first_name"])) {
      newErrors["first_name"] = `Invalid ${formMeta["first_name"]}!`;
    }
    if (!/^[A-Za-z ]{3,100}$/.test(formData["father"])) {
      newErrors["father"] = `Invalid ${formMeta["father"]}!`;
    }

    if (!validateDateofBirth(formData["dob"])) {
      newErrors["dob"] = "Invalid Date of Birth.";
    }
*/
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      notify("Error Validating the Form (2)", "error");
      return;
    }

    setLoading2(true);
    var formData2 = new FormData();

    Object.keys(formData).forEach((key) => {
      formData2.append(`Personal[${key}]`, formData[key]);
    });
    formData2.append(`Personal[nationality]`, formData.nationality.value);
    attApi
      .post("/add-personal-info", formData2, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === false) {
            Object.keys(res.data.errors).forEach((errorKey) => {
              newErrors[errorKey] = res.data.errors[errorKey];
            });
            setErrors(newErrors);
            notify("Error Validating the Form", "error");
          } else {
            notify(res.data.message, "success");
            getFillStatus();
            if (btnName === "savenext-button") {
              navigate(`/contact`);
            }
          }
        } else {
          notify(res.data.message, "error");
        }
      })
      .catch((err) => {
        notify("Error Validating the Form", "error");
      })
      .finally(() => {
        setLoading2(false);
      });
  }

  const YesNoList = { 0: Trans("No"), 1: Trans("Yes") };
  const GenderList = {
    M: Trans("Male"),
    F: Trans("Female"),
    O: Trans("Other"),
  };
  return (
    <div className="">
      {loading || siteInfo === null ? (
        <DataLoading />
      ) : (
        <>
          <p>{siteInfo.personal_info}</p>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <TextInput
                    name="first_name"
                    label={formMeta.first_name}
                    value={formData.first_name}
                    length={100}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    errors={errors}
                    disabled={true}
                  />
                </div>

                <div className="col-md-4">
                  <TextInput
                    name="father"
                    label={formMeta.father}
                    value={formData.father}
                    length={100}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="col-md-4">
                  <TextInput
                    name="mother_name"
                    label={formMeta.mother_name}
                    value={formData.mother_name}
                    length={100}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    errors={errors}
                  />
                </div>
                <div className="col-md-4">
                  <DropDownList
                    name="gender"
                    label={formMeta.gender}
                    value={formData.gender}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    prompt={"-Select-"}
                    listData={GenderList}
                    errors={errors}
                  />
                </div>
                <div className="col-md-4">
                  <DateInput
                    name="dob"
                    label={formMeta.dob}
                    value={formData.dob}
                    length={10}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    errors={errors}
                  />
                </div>

                {siteInfo && siteInfo.detail_info === "1" ? (
                  <>
                    <div className="col-md-4">
                      <TextInput
                        name="pob"
                        label={formMeta.pob}
                        value={formData.pob}
                        length={150}
                        handleInputChange={handleInputChange}
                        reqCols={reqCols}
                        errors={errors}
                        placeholder="Karachi"
                      />
                    </div>
                    <div className="col-md-4">
                      <Select2
                        name="nationality"
                        label={formMeta.nationality}
                        value={formData.nationality}
                        handleInputChange={handleInputChange}
                        reqCols={reqCols}
                        prompt={"-Select-"}
                        listData={CountriesList}
                        errors={errors}
                      />
                    </div>
                    <div className="col-md-4">
                      <DropDownList
                        name="religion"
                        label={formMeta.religion}
                        value={formData.religion}
                        handleInputChange={handleInputChange}
                        reqCols={reqCols}
                        prompt={"-Select-"}
                        listData={props.religions}
                        errors={errors}
                      />
                    </div>
                    <div className="col-md-4">
                      <DropDownList
                        name="blood_grp"
                        label={formMeta.blood_grp}
                        value={formData.blood_grp}
                        handleInputChange={handleInputChange}
                        reqCols={reqCols}
                        prompt={"-Select-"}
                        listData={bloodGroups}
                        errors={errors}
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div className="col-md-4">
                  <MaskedInput2
                    mask="11111-1111111-1"
                    name="cnic"
                    label={formMeta.cnic}
                    value={formData.cnic}
                    length={20}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    errors={errors}
                    disabled={true}
                  />
                </div>

                {siteInfo && siteInfo.detail_info === "1" ? (
                  <div className="col-md-4">
                    <DateInput
                      name="cnic_expiry"
                      label={formMeta.cnic_expiry}
                      value={formData.cnic_expiry}
                      length={10}
                      handleInputChange={handleInputChange}
                      reqCols={reqCols}
                      errors={errors}
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className="col-md-4">
                  <TextInput
                    name="passport"
                    label={formMeta.passport}
                    value={formData.passport}
                    length={20}
                    handleInputChange={handleInputChange}
                    reqCols={reqCols}
                    errors={errors}
                    placeholder="XXXXXX"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <img
                    src={dp}
                    height="150px"
                    width="150px"
                    style={{
                      borderRadius: "150px",
                      objectFit: "contain",
                      margin: "auto",
                    }}
                    className={`thumbnail mb-3 ${
                      errors.img ? "border border-danger" : ""
                    }`}
                    alt="DP"
                  />

                  {allowImgChange ? (
                    <div className="form-group">
                      <label className="control-label" htmlFor="img">
                        {formMeta.img}
                      </label>
                      <span
                        style={{ color: "red", marginRight: 4, marginLeft: 10 }}
                      >
                        *
                      </span>
                      <input
                        type="file"
                        id="img"
                        name="img"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={onImageChange}
                        className={` ${errors["img"] ? "is-invalid" : ""}`}
                      />
                      <div className="invalid-feedback">{errors["img"]}</div>
                      <p className="mt-3 text-info">
                        Please upload recent not more than six month old
                        passport size photograph having blue background. Click{" "}
                        <b>
                          <span role="button" onClick={() => openModal()}>
                            Here
                          </span>
                        </b>{" "}
                        to view accepted image samples
                      </p>
                      <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={closeModal}
                        contentLabel="Image Modal"
                        className="Modal"
                        overlayClassName="Overlay"
                      >
                        <img
                          src="/imgs/sample.jpeg"
                          alt="Guidline"
                          className="modal-image"
                        />
                        <br />
                        <button
                          onClick={closeModal}
                          className="btn btn-primary mt-3 text-center"
                        >
                          Close
                        </button>
                      </Modal>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-4">
                      <DropDownList
                        name="disability"
                        label={formMeta.disability}
                        value={formData.disability}
                        handleInputChange={handleInputChange}
                        reqCols={reqCols}
                        prompt={"-Select-"}
                        listData={YesNoList}
                        errors={errors}
                      />
                    </div>

                    {formData && formData.disability === "1" ? (
                      <>
                        <div className="col-md-8">
                          <TextInput
                            name="disability_nature"
                            label={formMeta.disability_nature}
                            value={formData.disability_nature}
                            length={100}
                            handleInputChange={handleInputChange}
                            reqCols={reqCols}
                            errors={errors}
                          />
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label
                              className="control-label"
                              htmlFor="disability_img"
                            >
                              {formMeta.disability_img}
                            </label>
                            <input
                              type="file"
                              id="disability_img"
                              name="disability_img"
                              onChange={onImageChange}
                              accept="image/png, image/jpeg, image/jpg"
                              className={` ${
                                errors["disability_img"] ? "is-invalid" : ""
                              }`}
                            />
                            <div className="invalid-feedback">
                              {errors["disability_img"]}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {disImg === "" ? (
                            <></>
                          ) : (
                            <img
                              src={disImg}
                              height="150px"
                              width="150px"
                              className={`thumbnail mb-3 `}
                              alt=""
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="col-md-4">
                      <DropDownList
                        name="hafizquran"
                        label={formMeta.hafizquran}
                        value={formData.hafizquran}
                        handleInputChange={handleInputChange}
                        reqCols={reqCols}
                        prompt={"-Select-"}
                        listData={YesNoList}
                        errors={errors}
                      />
                    </div>
                    <div className="col-md-8"></div>
                    {formData && formData.hafizquran === "1" ? (
                      <>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="control-label" htmlFor="hq_image">
                              {formMeta.hq_image}
                            </label>
                            <input
                              type="file"
                              id="hq_image"
                              name="hq_image"
                              onChange={onImageChange}
                              accept="image/png, image/jpeg, image/jpg"
                              className={` ${
                                errors["hq_image"] ? "is-invalid" : ""
                              }`}
                            />
                            <div className="invalid-feedback">
                              {errors["hq_image"]}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {hqImg === "" ? (
                            <></>
                          ) : (
                            <img
                              src={hqImg}
                              height="150px"
                              width="150px"
                              className={`thumbnail mb-3 `}
                              alt=""
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-group mt-3">
                {loading2 ? (
                  <DataLoading />
                ) : (
                  <>
                    {allowSave ? (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        name="save-button"
                        onClick={saveData}
                      >
                        {Trans(
                          applicantStatus &&
                            applicantStatus.personalInfo === true
                            ? "Update"
                            : "Save"
                        )}
                      </button>
                    ) : (
                      <></>
                    )}
                    {applicantStatus &&
                    applicantStatus.personalInfo === true &&
                    applicantStatus.application_submitted === false ? (
                      <button
                        type="submit"
                        className="btn btn-outline-secondary m-2"
                        name="savenext-button"
                        onClick={saveData}
                      >
                        {Trans("Next")}
                      </button>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Profile;
